var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1712 14.7162C12.0519 14.7162 11.9327 14.6885 11.8239 14.6315L7.99966 12.6335L4.17541 14.6315C3.92191 14.7635 3.61591 14.7403 3.38716 14.5723C3.15616 14.4043 3.04141 14.12 3.08941 13.8387L3.81841 9.61775L0.72841 6.629C0.52216 6.43025 0.44866 6.13175 0.53641 5.8595C0.62341 5.58725 0.85891 5.38925 1.14166 5.348L5.41741 4.727L7.32766 0.8825C7.58116 0.3725 8.41816 0.3725 8.67166 0.8825L10.5819 4.727L14.8577 5.348C15.1404 5.38925 15.3759 5.58725 15.4629 5.8595C15.5507 6.13175 15.4772 6.43025 15.2709 6.629L12.1809 9.61775L12.9099 13.8387C12.9579 14.12 12.8432 14.4043 12.6122 14.5723C12.4824 14.6683 12.3272 14.7162 12.1712 14.7162Z",
    fill: "#FFBC7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.30598d08.svg";
export { ForwardRef as ReactComponent };